import { OrderDto } from '../../dto/order';
import { getDisplayOrderNumber } from '../../types/order';

export interface CustomerOrderLinkOption {
  value: string;
  label: string;
}

export function buildCustomerOrderLinkOption(order: OrderDto): CustomerOrderLinkOption {
  return {
    value: order.id,
    label: [
      getDisplayOrderNumber(order),
      order.customer?.name || order.customerName,
    ].filter(Boolean).join(' - '),
  };
}

export function buildCustomerOrderLinkOptions(orders: OrderDto[]): CustomerOrderLinkOption[] {
  return orders.map(buildCustomerOrderLinkOption);
}
